// extracted by mini-css-extract-plugin
module.exports = {"header":"BpQqpgAZ9nQf30W4edVtC","calcInput":"_1iV8o162dOv64oSxTSj-4L","calcResult":"_26_fB6oLLb6v-Y2Zlkho8A","numText":"NQX0WP8kXE4jX4Nn_VT6m","spinner":"IobtV9dERDNH5K31-n4wC"};